import { Link } from 'react-router-dom';
import type { components } from '@bookingdei/api-client/types';
import { useLanguage } from '../../shell/language-context';
import { useFavorites } from '../../shell/favorites-context';
import { Cover } from './hx-cover';
import { Ic } from './hx-icon';
import type { HomeFormat } from './use-home-format';

type BusinessSummary = components['schemas']['BusinessSummary'];

// The Home design's listing card (`.lc`): cover with the Save heart over it, the category
// eyebrow, name, area, rating and "From" price. A card surfaced from an ad slot carries the
// visible "Sponsored" label (AP-D10). The link wraps the picture and the text with
// `display: contents`, so the heart (a sibling button, never nested in the link) keeps the
// card's own layout. Cards open /b/{slug} (DR-40).
export function HxListingCard({ business, fmt }: { business: BusinessSummary; fmt: HomeFormat }) {
  const { t, lang } = useLanguage();
  const favorites = useFavorites();
  const name = lang === 'bn' && business.name_bn ? business.name_bn : business.name;
  const saved = favorites.isSaved(business.id);
  return (
    <div className="lc rv">
      <Link to={`/b/${business.slug}`} className="lc__a">
        <Cover src={business.cover_image?.['800'] ?? business.cover_image?.['400']} categoryId={business.category_id} id={business.id} />
        <div className="lt">
          <span className="cat">
            {fmt.catLabel(business.category_id)}
            {business.sponsored ? <> · {t('dc50.card.sponsored')}</> : null}
          </span>
          <b>{name}</b>
          <small>{business.area_name}</small>
          <div className="row">
            <span className="rt">
              <Ic id="star" />
              {fmt.rating(business.rating)} <i>({fmt.num(business.review_count)})</i>
            </span>
            <span className="pr">{fmt.priceFrom(business)}</span>
          </div>
        </div>
      </Link>
      <button
        type="button"
        className={saved ? 'hrt on' : 'hrt'}
        aria-pressed={saved}
        aria-label={t(saved ? 'dc50.card.unsave' : 'dc50.card.save', { name })}
        onClick={() => favorites.toggle(business.id)}
      >
        <Ic id="heart" />
      </button>
    </div>
  );
}
